import { z } from 'zod'

import { GetUserSchema } from './user.ts'

export const CommissionStatusSchema = z.enum(['draft', 'settled'])

export type CommissionStatus = z.infer<typeof CommissionStatusSchema>

export const CommissionAssigneeActionSchema = z.enum(['assigned', 'unassigned'])

export type CommissionAssigneeAction = z.infer<typeof CommissionAssigneeActionSchema>

export const CommissionFieldAliasSchema = z.enum([
  'TYPE_045',
  'TYPE_010',
  'TYPE_040',
  'URGENT',
  'POD',
])

export type CommissionFieldAlias = z.infer<typeof CommissionFieldAliasSchema>

export const GetCommissionFieldSchema = z.object({
  alias: z.string(),
  id: z.number(),
  is_active: z.boolean(),
  title: z.string(),
  value: z.string().nullable(),
})

export const GetCommissionRoleUsersSchema = z.object({
  role: z.object({
    id: z.number(),
    name: z.string(),
  }),
  users: GetUserSchema.array(),
})

export type CommissionRoleUsers = z.infer<typeof GetCommissionRoleUsersSchema>

export const GetCommissionAssigneeSchema = z.object({
  created_at: z.coerce.date(),
  field: GetCommissionFieldSchema,
  id: z.number(),
  user: GetUserSchema,
})

export const GetCommissionAssigneeHistorySchema = z.object({
  action: CommissionAssigneeActionSchema,
  changed_by: GetUserSchema.nullish(),
  commission_field: GetCommissionFieldSchema.nullish(),
  created_at: z.coerce.date(),
  field: z.string(),
  id: z.number(),
  user: GetUserSchema.nullish(),
})

export const GetCommissionSchema = z.object({
  created_at: z.coerce.date(),
  id: z.number(),
  load_id: z.number(),
  status: CommissionStatusSchema.nullable(),
})

export const CommissionWithAssigneesSchema = GetCommissionSchema.extend({
  assignees: GetCommissionAssigneeSchema.array(),
})

export const SyncCommissionAssigneesBodySchema = z.object({
  commission_field_id: z.number().int().positive(),
  user_ids: z.number().int().positive().array(),
})

export type SyncCommissionAssigneesBody = z.infer<typeof SyncCommissionAssigneesBodySchema>
